// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-text-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1% 10%; 
    width:80%
  }

  .image-text-container img {
    max-width: 40%; 
    height: auto;
  }
  
  .text-container {
    text-align: center; 
  }
  
  .text-container p {
    margin: 0;
    text-align: justify;
    padding-left: 5%;
  
  }
  
  .text-container .title {
    text-align: left;
    display: flex;
    justify-content: justify;
    font-weight: 800;
    color: #ff8f00;
    
  }
  
  .text-container .authors {
    color: #ff8f00;
    font-weight: lighter;
    padding-bottom: 0.5vw;
  }
  .text-container .content {
    padding-bottom: 1vw;
  }
  .poster-link {
    margin-top: 10px;
  }
  
  .poster-link a {
    color: white;
    background-color: #c43e00; 
    padding: 7px 17px;
    text-decoration: none;
    border-radius: 5px;
    display: inline-block;
    transition: background-color 0.3s ease;
  }
  
  .poster-link a:hover {
    background-color: #e87844; 
  }
  
  .poster-link a:focus {
    outline: 2px solid #e87844; 
    outline-offset: 2px;
  }
  
  @media (min-width: 768px) {
   
    .image-text-container {
      flex-direction: row; 
    }
  
    .image-text-container img {
    display: flex;
    flex-direction: column; 
    align-items: center;
    padding: 1% 1%; 
    width:80%
    }
  }
  
  @media (min-width: 1500px) {
    .text-container { 
      font-size: 1.4rem;
    }

    .image-text-container img {
      max-width: 45%; 
      height: auto;
    }
  }

  @media (max-width: 768px) { 
    .image-text-container img {
      min-width: 90%; 
      max-width: 90%; 

    }

    .text-container {
      display: flex; 
      flex-direction: column;
      justify-content: center;
      padding-top: 5%;

      
    }
    .text-container p {
     width: 100%;
     margin-left: -5%;
     
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/ResearchComponent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf;EACF;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,gBAAgB;;EAElB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;;EAEhB;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;;IAEE;MACE,mBAAmB;IACrB;;IAEA;IACA,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd;IACA;EACF;;EAEA;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,cAAc;MACd,YAAY;IACd;EACF;;EAEA;IACE;MACE,cAAc;MACd,cAAc;;IAEhB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,eAAe;;;IAGjB;IACA;KACC,WAAW;KACX,gBAAgB;;IAEjB;EACF","sourcesContent":[".image-text-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding: 1% 10%; \r\n    width:80%\r\n  }\r\n\r\n  .image-text-container img {\r\n    max-width: 40%; \r\n    height: auto;\r\n  }\r\n  \r\n  .text-container {\r\n    text-align: center; \r\n  }\r\n  \r\n  .text-container p {\r\n    margin: 0;\r\n    text-align: justify;\r\n    padding-left: 5%;\r\n  \r\n  }\r\n  \r\n  .text-container .title {\r\n    text-align: left;\r\n    display: flex;\r\n    justify-content: justify;\r\n    font-weight: 800;\r\n    color: #ff8f00;\r\n    \r\n  }\r\n  \r\n  .text-container .authors {\r\n    color: #ff8f00;\r\n    font-weight: lighter;\r\n    padding-bottom: 0.5vw;\r\n  }\r\n  .text-container .content {\r\n    padding-bottom: 1vw;\r\n  }\r\n  .poster-link {\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .poster-link a {\r\n    color: white;\r\n    background-color: #c43e00; \r\n    padding: 7px 17px;\r\n    text-decoration: none;\r\n    border-radius: 5px;\r\n    display: inline-block;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .poster-link a:hover {\r\n    background-color: #e87844; \r\n  }\r\n  \r\n  .poster-link a:focus {\r\n    outline: 2px solid #e87844; \r\n    outline-offset: 2px;\r\n  }\r\n  \r\n  @media (min-width: 768px) {\r\n   \r\n    .image-text-container {\r\n      flex-direction: row; \r\n    }\r\n  \r\n    .image-text-container img {\r\n    display: flex;\r\n    flex-direction: column; \r\n    align-items: center;\r\n    padding: 1% 1%; \r\n    width:80%\r\n    }\r\n  }\r\n  \r\n  @media (min-width: 1500px) {\r\n    .text-container { \r\n      font-size: 1.4rem;\r\n    }\r\n\r\n    .image-text-container img {\r\n      max-width: 45%; \r\n      height: auto;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) { \r\n    .image-text-container img {\r\n      min-width: 90%; \r\n      max-width: 90%; \r\n\r\n    }\r\n\r\n    .text-container {\r\n      display: flex; \r\n      flex-direction: column;\r\n      justify-content: center;\r\n      padding-top: 5%;\r\n\r\n      \r\n    }\r\n    .text-container p {\r\n     width: 100%;\r\n     margin-left: -5%;\r\n     \r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
